<div class="share-wpp-dialog-component gap-16" fxLayout="column">
    <div
        fxLayout="row"
        class="share-wpp-dialog-component__header"
        fxLayoutAlign="space-between center"
    >
        <h1 class="text-16-semi-bold color-text-primary">
            Compartilhar por WhatsApp
        </h1>
        <dsn-button-menu-chips
            [mainIcon]="'fa-solid fa-xmark'"
            size="medium"
            (onClick)="this.dialogRef.close()"
        ></dsn-button-menu-chips>
    </div>

    <div
        fxLayout="column"
        class="share-wpp-dialog-component__message"
        fxLayoutAlign="start none"
    >
        <span class="color-text-primary text-14-regular">
            Envie para usuários cadastrados e/ou para outros contatos</span
        >
    </div>
    <div
        class="share-wpp-dialog-component__section gap-16"
        fxFlex
        fxLayout="row"
        fxLayoutAlign="space-between none"
    >
        <div
            class="share-wpp-dialog-component__column gap-8 full-height"
            fxLayout="column"
            fxFlex="58"
        >
            <app-share-list-select
                [chips]="chips"
                [disableActions]="data.companyId == 'EMPRESA_MODELO'"
                [label]="'Não é usuário? Escreva o número abaixo*'"
                [typeChips]="'phone'"
                [placeholderChips]="'Digite o número de WhatsApp'"
                [invalidMessageChips]="
                    'Número inválido. Informe DDD + número com 9 dígitos.'
                "
                [filterType]="'whatsapp'"
                class="full-height"
                style="min-height: 64px"
                [categories]="categories"
                [categoriesSignal]="categoriesSignal"
                (handleContactDialog)="onOpenAddContact($event)"
                (handleUpdateContact)="onUpdateContact($event)"
            ></app-share-list-select>
        </div>
        <div class="share-wpp-dialog-component__column" fxFlex>
            <app-share-list [ships]="handleChips()"></app-share-list>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center" class="gap-12">
        <dsn-button
            [label]="'Modelo da mensagem'"
            [type]="'outline'"
            [size]="'medium'"
            [active]="false"
            [fontWeight]="'bold'"
            (onClick)="onOpenModelWhatsapp()"
        ></dsn-button>
        <dsn-button
            (onClick)="onSubmit()"
            [label]="'Compartilhar'"
            [type]="'primary'"
            [size]="'medium'"
            [disabled]="!getContactsSelected()?.length && !this.chips.length"
            [iconLeft]="'fa-solid fa-share'"
            [fontWeight]="'bold'"
        ></dsn-button>
    </div>
</div>
